export const mediaQueries = {
  tab: "max-width: 1023px",
};

export const matchMediaQuery = (mq) => {
  return window.matchMedia(`(${mq})`).matches;
};
